/** Уровень качества детали. Выше - лучше, меньше - хуже */
export enum TechTuningRarity {
	/** Уровень 1 */
	COMMON = 'common',
	/** Уровень 2 */
	UNCOMMON = 'uncommon',
	/** Уровень 3 */
	RARE = 'rare',
	/** Уровень 4 */
	EPIC = 'epic',
	/** Уровень 5 */
	LEGENDARY = 'legendary',
}

/** Секции (разделы) в кастомных настройках хендлинга */
export enum TechTuningSection {
	TRANSMISSION = 'transmission',
	SUSPENSION = 'suspension',
	ENGINE = 'engine',
	BRAKES = 'brakes',
	TYRES = 'tyres',
}

export enum TechTuningItemProperty {
	/** Максимальная скорость (бонус в км/ч) */
	BOOST = 'boost',
	/** Ускорение */
	ACCELERATION = 'acceleration',
	/** Сцепление шин */
	TRACTION = 'traction',
	/** Торможение */
	BRAKING = 'braking',
}

/** Категории тюнинга */
export enum TechTuningCategory {
	SETTINGS = 'settings',
	ENGINE = 'engine',
	TURBO = 'turbo',
	EXHAUST = 'exhaust',
	RADIATOR = 'radiator',
	STARTER = 'starter',
	BRAKES = 'brakes',
	SUSPENSION = 'suspension',
	TIRES = 'tires',
}

export function getHandlingPropertyByTuningProperty(techTuningItemProperty: TechTuningItemProperty): string | null {
	switch (techTuningItemProperty) {
		case TechTuningItemProperty.BRAKING:
			return 'fBrakeForce';
		case TechTuningItemProperty.TRACTION:
			return 'fTractionCurveMin';
		case TechTuningItemProperty.ACCELERATION:
			return 'fInitialDriveForce';

		default:
			return null;
	}
}

export enum TechTuningCaseType {
	STANDART = 'standart',
	DIAMOND = 'diamond',
	MAXIMUM = 'maximum',
}
